import { Menu } from "./menu.model";

export const canSearch: Menu = new Menu(0, "Customer Search", "/customer-search", null, "search", null, false, 0);

// the menu IDs are used in  sidenav.component.ts as part of the logic for which menu items to display and how to
// handle various clicks- i.e. prebuy, etc. don't change IDs...unless you change sidenav.component.ts and
// vertical-menu.component.ts logic as well.
export const verticalMenuItems = [
    new Menu(1, `Home`, `/home`, null, `dashboard`, null, false, 0),
    new Menu(4, `Locations`, `/location`, null, `location_on`, null, false, 0),
    new Menu(2, `Transactions`, `/transactions`, null, `request_quote`, null, false, 0),
    new Menu(3, `Equipment`, `/equipment`, null, `list`, null, false, 0),
    new Menu(7, `Contracts`, `/contracts`, null, `receipt_long`, null, false, 0),
    new Menu(8, `Prebuy Setup`, `/prebuy`, null, `shopping_cart`, null, false, 0),
    new Menu(12, `Documents`, `/documents`, null, `description`, null, false, 0),
    new Menu(5, `My Account`, `/account-details`, null, `person`, null, false, 0),
    new Menu(6, `Contact Us`, `/contact-us`, null, `perm_phone_msg`, null, false, 0),

];

// the menu IDs are used in  sidenav.component.ts as part of the logic for which menu items to display and how to
// handle various clicks- i.e. prebuy, etc. don't change IDs...unless you change sidenav.component.ts and
// vertical-menu.component.ts logic as well.
export const horizontalMenuItems = [
    new Menu(1, `Home`, `/home`, null, `dashboard`, null, false, 0),
    new Menu(4, `Locations`, `/location`, null, `location_on`, null, false, 0),
    new Menu(2, `Transactions`, `/transactions`, null, `request_quote`, null, false, 0),
    new Menu(3, `Equipment`, `/equipment`, null, `list`, null, false, 0),
    new Menu(7, `Contracts`, `/contracts`, null, `receipt_long`, null, false, 0),
    new Menu(8, `Prebuy Setup`, `/prebuy`, null, `shopping_cart`, null, false, 0),
    new Menu(12, `Documents`, `/documents`, null, `description`, null, false, 0),
    new Menu(5, `My Account`, `/account-details`, null, `person`, null, false, 0),
    new Menu(6, `Contact Us`, `/contact-us`, null, `perm_phone_msg`, null, false, 0),
];


